/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ModelClassEnum } from './ModelClassEnum';
import { ModelClassEnumFromJSON, ModelClassEnumFromJSONTyped, ModelClassEnumToJSON } from './ModelClassEnum';

/**
 *
 * @export
 * @interface TabularMLDataset
 */
export interface TabularMLDataset {
  /**
   *
   * @type {number}
   * @memberof TabularMLDataset
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof TabularMLDataset
   */
  datasetPath: string;
  /**
   *
   * @type {boolean}
   * @memberof TabularMLDataset
   */
  readonly hasPredictions: boolean;
  /**
   *
   * @type {ModelClassEnum}
   * @memberof TabularMLDataset
   */
  modelClass: ModelClassEnum;
}

/**
 * Check if a given object implements the TabularMLDataset interface.
 */
export function instanceOfTabularMLDataset(value: object): value is TabularMLDataset {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('datasetPath' in value) || value['datasetPath'] === undefined) return false;
  if (!('hasPredictions' in value) || value['hasPredictions'] === undefined) return false;
  if (!('modelClass' in value) || value['modelClass'] === undefined) return false;
  return true;
}

export function TabularMLDatasetFromJSON(json: any): TabularMLDataset {
  return TabularMLDatasetFromJSONTyped(json, false);
}

export function TabularMLDatasetFromJSONTyped(json: any, ignoreDiscriminator: boolean): TabularMLDataset {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    datasetPath: json['dataset_path'],
    hasPredictions: json['has_predictions'],
    modelClass: ModelClassEnumFromJSON(json['model_class']),
  };
}

export function TabularMLDatasetToJSON(value?: Omit<TabularMLDataset, 'id' | 'hasPredictions'> | null): any {
  if (value == null) {
    return value;
  }
  return {
    dataset_path: value['datasetPath'],
    model_class: ModelClassEnumToJSON(value['modelClass']),
  };
}
